<template>
    <v-form ref="formEce" id="formEce" lazy-validation>
        <template v-if="$storeCandidature.configurationClient.ParamFormulaire.Decommissionner == true && !$route.query.cdt">
            <PageDecommissionner/>
        </template>
        <template v-else>
            <div class="mb-2 ml-3">
                <v-img v-if="$storeCandidature.configurationClient.ParamFormulaire.LogoUrl"
                       :src="$storeCandidature.configurationClient.ParamFormulaire.LogoUrl"
                       style="max-height:10%; max-width:20%">
                </v-img>
                <div v-if="$storeCandidature.langueFormulaire == 'en'" id="entete" v-html="$storeCandidature.configurationClient.ParamFormulaire.EnTeteEN" class="mt-2">
                </div>
                <div v-else id="entete" v-html="$storeCandidature.configurationClient.ParamFormulaire.EnTeteFR" class="mt-2">
                </div>
            </div>
            <div class="font-weight-medium center headline mx-3 green"
                 v-if="$storeCandidature.sasCandidature.Statut && $storeCandidature.sasCandidature.Statut.Id == $storeCandidature.configurationClient.StatutCandidatureValideId">
                Votre candidature est validée
            </div>
            <div class="font-weight-medium center headline mx-3 orange"
                 v-if="$storeCandidature.sasCandidature.Statut && $storeCandidature.sasCandidature.Statut.Id == $storeCandidature.configurationClient.StatutCandidatAValiderId">
                Votre candidature est en attente de validation par l'ECE
            </div>
            <v-stepper class="mx-3" v-model="etape">
                <v-stepper-header>
                    <v-hover v-slot:default="{ hover }">
                        <v-card flat :elevation="hover ? 5 : (etape == 1 ? 2 : 0)">
                            <v-stepper-step step="1" :rules="[() => !showValidationFlag || $storeCandidature.ValidationIdentificationOK]" class="pb-3" v-on:click="naviguerEntete(1)">
                                Identification
                            </v-stepper-step>
                            <v-system-bar v-if="etape == 1" color="primary" height="4"></v-system-bar>
                        </v-card>
                    </v-hover>
                    <v-divider></v-divider>
                    <v-hover v-slot:default="{ hover }">
                        <v-card flat :elevation="hover ? 5 : (etape == 2 ? 2 : 0)">
                            <v-stepper-step step="2" :rules="[() => !showValidationFlag || $storeCandidature.ValidationChoixProgrammeOK]" class="pb-3" v-on:click="naviguerEntete(2)">
                                <span>{{$storeCandidature.langueFormulaire == 'en' ? 'Program' : 'Choix du programme'}}</span>
                            </v-stepper-step>
                            <v-system-bar v-if="etape == 2" color="primary" height="4"></v-system-bar>
                        </v-card>
                    </v-hover>
                    <v-divider></v-divider>
                    <v-hover v-slot:default="{ hover }">
                        <v-card flat :elevation="hover ? 5 : (etape == 3 ? 2 : 0)">
                            <v-stepper-step step="3" :rules="[() => !showValidationFlag || $storeCandidature.ValidationInformationSupplementaireOK]" class="pb-3" v-on:click="naviguerEntete(3)">
                                <span>{{$storeCandidature.langueFormulaire == 'en' ? 'Additional Informations' : 'Info complémentaires'}}</span>
                            </v-stepper-step>
                            <v-system-bar v-if="etape == 3" color="primary" height="4"></v-system-bar>
                        </v-card>
                    </v-hover>
                    <!--<v-divider></v-divider>
                    <v-hover v-slot:default="{ hover }">
                        <v-card flat :elevation="hover ? 5 : (etape == 4 ? 2 : 0)">
                            <v-stepper-step step="4" :rules="[() => !showValidationFlag || $storeCandidature.ValidationInformationSupplementaire2OK]" class="pb-3" v-on:click="naviguerEntete(4)">
                                <span>{{$storeCandidature.langueFormulaire == 'en' ? 'Additional Informations 2/2' : 'Info complémentaires 2/2'}}</span>
                            </v-stepper-step>
                            <v-system-bar v-if="etape == 4" color="primary" height="4"></v-system-bar>
                        </v-card>
                    </v-hover>-->
                    <v-divider></v-divider>
                    <v-hover v-slot:default="{ hover }">
                        <v-card flat :elevation="hover ? 5 : (etape == 4 ? 2 : 0)">
                            <v-stepper-step step="4" :rules="[() => !showValidationFlag || $storeCandidature.ValidationPiecesJointesOK]" class="pb-3" v-on:click="naviguerEntete(4)">
                                <span>{{$storeCandidature.langueFormulaire == 'en' ? 'Supporting documentation' : 'Pièces jointes'}}</span>
                            </v-stepper-step>
                            <v-system-bar v-if="etape == 4" color="primary" height="4"></v-system-bar>
                        </v-card>
                    </v-hover>
                    <v-divider></v-divider>
                    <v-hover v-slot:default="{ hover }">
                        <v-card flat :elevation="hover ? 5 : (etape == 5 ? 2 : 0)">
                            <v-stepper-step step="5" :rules="[() => !showValidationFlag || $storeCandidature.ValidationPaiementOK]" class="pb-3" v-on:click="naviguerEntete(5)">
                                <span>{{$storeCandidature.langueFormulaire == 'en' ? 'Payment' : 'Paiement'}}</span>
                            </v-stepper-step>
                            <v-system-bar v-if="etape == 5" color="primary" height="4"></v-system-bar>
                        </v-card>
                    </v-hover>
                    <v-divider></v-divider>
                    <v-hover v-slot:default="{ hover }">
                        <v-card flat :elevation="hover ? 5 : (etape == 6 ? 2 : 0)">
                            <v-stepper-step step="6" :rules="[() => !showValidationFlag || $storeCandidature.etapeValidationValide]" class="pb-3" v-on:click="naviguerEntete(6)">
                                <span>{{$storeCandidature.langueFormulaire == 'en' ? 'Application Summary' : 'Validation'}}</span>
                            </v-stepper-step>
                            <v-system-bar v-if="etape == 6" color="primary" height="4"></v-system-bar>
                        </v-card>
                    </v-hover>
                </v-stepper-header>
                <v-stepper-items>
                    <!--Etape3 : Identification-->
                    <v-stepper-content step="1">
                        <Tab1_Identification etape="1" />
                    </v-stepper-content>
                    <!--Etape2 : Choix du programme-->
                    <v-stepper-content step="2">
                        <Tab2_ChoixProgramme etape="2" />
                    </v-stepper-content>
                    <!--Etape3 : Informations complémentaires-->
                    <v-stepper-content step="3">
                        <Tab3_InfoSupplementaire />
                    </v-stepper-content>
                    <!--Etape4 : Informations complémentaires 2-->
                    <!--<v-stepper-content step="4">
                        <Tab4_InfoSupplementaire2 />
                    </v-stepper-content>-->
                    <!--Etape4 : Pieces jointes-->
                    <v-stepper-content step="4">
                        <Tab4_PiecesJointes />
                    </v-stepper-content>
                    <!--Etape5 : Paiement-->
                    <v-stepper-content step="5">
                        <Tab5_Paiement />
                    </v-stepper-content>
                    <!--Etape6 : Validation-->
                    <v-stepper-content step="6">
                        <Tab6_Validation />
                    </v-stepper-content>
                </v-stepper-items>
            </v-stepper>

            <!--changé : {{this.$storeCandidature.candidatureChanged}}-->
            <div class="center mt-3"
                 v-if="!$storeCandidature.sasCandidature.Statut || ($storeCandidature.sasCandidature.Statut.Id == $storeCandidature.configurationClient.StatutCandidatureEnCoursId)">
                <p caption
                   v-if="showError"
                   class="center headline red--text">Une erreur s'est produite lors du traitement</p>
                <p caption
                   v-if="showErrorValidation"
                   class="center headline red--text">{{messageErreurValidation}}</p>
                <v-btn v-if="etape>1" class="mr-3" color="info" :loading="loadingBouton" :disabled="loadingBouton" @click="executerEtChangerEtape(etape - 1, true)">Précédent</v-btn>
                <v-btn v-if="etape<6" color="primary" :loading="loadingBouton" :disabled="loadingBouton" @click="naviguerVersEtape(etape + 1)">Suivant</v-btn>
                <v-btn v-if="etape==6" :loading="loadingBouton"
                       :disabled="showErrorValidation ? '' : false"
                       color="success"
                       @click="naviguerVersEtape(6)">Valider</v-btn>
            </div>
            <div class="font-weight-medium center headline mx-3 green"
                 v-if="$storeCandidature.sasCandidature.Statut && $storeCandidature.sasCandidature.Statut.Id == $storeCandidature.configurationClient.StatutCandidatureValideId">
                Votre candidature est validée
            </div>
            <div class="font-weight-medium center headline mx-3 orange"
                 v-if="$storeCandidature.sasCandidature.Statut && $storeCandidature.sasCandidature.Statut.Id == $storeCandidature.configurationClient.StatutCandidatAValiderId">
                Votre candidature est en attente de validation par l'ECE
            </div>
            <div v-if="$storeCandidature.langueFormulaire == 'en'" id="footer" v-html="$storeCandidature.configurationClient.ParamFormulaire.FooterEN" class="mx-3">
            </div>
            <div v-else id="footer" v-html="$storeCandidature.configurationClient.ParamFormulaire.Footer" class="mx-3">
            </div>
            <DialogRedirection />
        </template>
    </v-form>
</template>
<script>
    import Tab1_Identification from "../components/CandidatureIdentification.vue";
    import Tab2_ChoixProgramme from "../components/CandidatureChoixProgramme.vue";
    import Tab3_InfoSupplementaire from "../components/CandidatureInfosSupplementaires.vue";
    import Tab4_PiecesJointes from "../components/CandidatureListePiecesJointes.vue";
    import Tab5_Paiement from "../components/CandidaturePaiement.vue";
    import Tab6_Validation from "../components/CandidatureValidationEce.vue";
    import DialogRedirection from "../components/CandidatureRedirectionDialog.vue";
    import PageDecommissionner from "../components/FormulaireDecommissionne.vue";

    export default {
        components: {
            Tab1_Identification,
            Tab2_ChoixProgramme,
            Tab3_InfoSupplementaire,
            Tab4_PiecesJointes,
            Tab5_Paiement,
            Tab6_Validation,
            DialogRedirection,
            PageDecommissionner
        },

        data() {
            return {
                // Réaffecter l'objet global pour forcer la maj en temps réel
                $storeCandidature: this.$storeCandidature,
                dataIdEcoleEce: 1003411,
                dataIdFormulaireEce: 1006688,
                etape: 1,
                candidatureCharge: false,
                loadingBouton: false,
                showError: false,
                showErrorValidation: false,
                showValidationFlag: false,
                messageErreurValidation: "Veuillez renseigner les champs obligatoires",
            };
        },

        methods: {
            // Récupérer le path des tags à envoyer selon l'étape
            getTagPath() {
                switch (this.etape) {
                    case 1:
                        return 'tunnel-candidature_etape1-identification'
                    case 2:
                        return 'tunnel-candidature_etape2-choix-programme'
                    case 3:
                        return 'tunnel-candidature_etape3-info-complementaire01'
                    //case 4:
                    //    return 'tunnel-candidature_etape4-info-complementaire02'
                    case 4:
                        return 'tunnel-candidature_etape4-pièces-jointes'
                    case 5:
                        return 'tunnel-candidature_etape5-paiement'
                    case 6:
                        return 'tunnel-candidature_etape6-validation'

                    default:
                        return null
                }
            },

            // Récupérer le type des tags à envoyer selon l'étape
            getTagType() {
                switch (this.etape) {
                    case 1:
                        return 'CANDIDATURE-IDENTIFICATION'
                    case 2:
                        return 'CANDIDATURE-CHOIX-PROGRAMME'
                    case 3:
                        return 'CANDIDATURE-INFOS-COMPLEMENTAIRES'
                    case 4:
                        return 'CANDIDATURE-PIECES-JOINTES'
                    case 5:
                        return 'CANDIDATURE-PAIEMENT'
                    case 6:
                        return 'CANDIDATURE-VALIDATION'
                    default:
                        return null
                }
            },

            // Fonction de navigation entête
            naviguerEntete(etapeSuivante) {
                // On désactiv la navigation via entête si la candixature n'existe pas ou si elle n'est pas modifiable
                if (this.$storeCandidature.sasCandidature.Statut && this.$storeCandidature.configurationClient.StatutCandidatureEnCoursId
                    && this.$storeCandidature.sasCandidature.Statut.Id == this.$storeCandidature.configurationClient.StatutCandidatureEnCoursId
                    && etapeSuivante != this.etape) {

                    // Si nous somme dans l'étape de validation, on navigue directement à l'étape demandé
                    if (this.etape == 6) {
                        this.etape = etapeSuivante

                        // Si ce n'est pas l'étape de validation Envoi du tag Eularian pour l'étape
                        if (this.etape != 6) {
                            this.$storeCandidature.envoyerTagsAnalytics(this.$gtm, this.$eulerian, this.getTagPath(), this.getTagType(), false, null);
                        }

                        return
                    }

                    // Récupérer la première étape non valide avant l'étape demandé avant de continuer la navigation
                    this.naviguerVersEtape(this.checkPremierEtapeInvalide(etapeSuivante))
                }
            },

            // Fonction de navigation vers l'étape demandé
            naviguerVersEtape(etapeSuivante) {
                // si un changement a été  fait ou on est dans l'étape de validation ou on est à la première création, on valide et on sauvegrade l'étape
                if (this.$storeCandidature.candidatureChanged || this.etape == 2 || this.etape == 6 || !this.$storeCandidature.sasCandidature.IdCrypte) {

                    // Si non on appelle le srvice de valdiation et de sauvegarde sans vérification de doublon
                    if (!this.validerFormulaire()) {
                        return;
                    }
                    else {
                        this.executerEtChangerEtape(etapeSuivante, false);
                    }
                }
                else {
                    if (this.validerFormulaire()) {
                        this.loadingBouton = true
                        // Si c'est létape du choix de programme, on vérifie si ça nécessite une redirection pour concours
                        if (this.etape == 2) {
                            this.$storeCandidature.verifierRedirectionConcours().then(response => {
                                this.$storeCandidature.redirectionConcours = response.data
                                if (this.$storeCandidature.redirectionConcours.AfficherDialog) {
                                    this.etape = 2
                                    this.loadingBouton = false
                                }
                                else {
                                    // Appeler le web service d'initialisation du paiement si on part vers l'étape de paiement
                                    if (etapeSuivante == 5) {
                                        // Mettre à jour le mode de paiement
                                        this.$storeCandidature.sasCandidature.ModePaiementId = this.$storeCandidature.sasCandidature.ModePaiement ? this.$storeCandidature.sasCandidature.ModePaiement.Id.toString() : this.$storeCandidature.configurationClient.ModePaiementCbId.toString()
                                        this.$storeCandidature.sasCandidature.PaiementVirement = this.$storeCandidature.sasCandidature.ModePaiement && this.$storeCandidature.sasCandidature.ModePaiement.Id == this.$storeCandidature.configurationClient.ModePaiementVirementId


                                        this.$storeCandidature.chargerObjetDePaiement(this.$storeCandidature.sasCandidature.IdCrypte, this.$storeCandidature.sasCandidature.KeyCrypte)
                                            .then(response => {
                                                if (response.data) {
                                                    this.$storeCandidature.paiemenyDto = response.data;
                                                    this.etape = etapeSuivante
                                                    this.loadingBouton = false

                                                    // Si ce n'est pas l'étape de validation Envoi du tag Eularian pour l'étape
                                                    if (this.etape != 6) {
                                                        this.$storeCandidature.envoyerTagsAnalytics(this.$gtm, this.$eulerian, this.getTagPath(), this.getTagType(), false, null);
                                                    }
                                                }
                                            });
                                    }
                                    else {
                                        // Paser à l'étape demandé demandé directement
                                        this.etape = etapeSuivante
                                        this.loadingBouton = false

                                        // Si ce n'est pas l'étape de validation Envoi du tag Eularian pour l'étape
                                        if (this.etape != 6) {
                                            this.$storeCandidature.envoyerTagsAnalytics(this.$gtm, this.$eulerian, this.getTagPath(), this.getTagType(), false, null);
                                        }
                                    }
                                }
                            }).catch(() => {
                                alert('Une erreur est srvenue lors de la vérification de la redirection concours !')
                                this.loadingBouton = false
                            })
                        }
                        else {
                            // Appeler le web service d'initialisation du paiement si on part vers l'étape de paiement
                            if (etapeSuivante == 5) {
                                // Mettre à jour le mode de paiement
                                this.$storeCandidature.sasCandidature.ModePaiementId = this.$storeCandidature.sasCandidature.ModePaiement ? this.$storeCandidature.sasCandidature.ModePaiement.Id.toString() : this.$storeCandidature.configurationClient.ModePaiementCbId.toString()
                                this.$storeCandidature.sasCandidature.PaiementVirement = this.$storeCandidature.sasCandidature.ModePaiement && this.$storeCandidature.sasCandidature.ModePaiement.Id == this.$storeCandidature.configurationClient.ModePaiementVirementId

                                this.$storeCandidature.chargerObjetDePaiement(this.$storeCandidature.sasCandidature.IdCrypte, this.$storeCandidature.sasCandidature.KeyCrypte)
                                    .then(response => {
                                        if (response.data) {
                                            this.$storeCandidature.paiemenyDto = response.data;
                                            this.etape = etapeSuivante
                                            this.loadingBouton = false

                                            // Si ce n'est pas l'étape de validation Envoi du tag Eularian pour l'étape
                                            if (this.etape != 6) {
                                                this.$storeCandidature.envoyerTagsAnalytics(this.$gtm, this.$eulerian, this.getTagPath(), this.getTagType(), false, null);
                                            }
                                        }
                                    });
                            }
                            else {
                                // Paser à l'étape demandé demandé directement
                                this.etape = etapeSuivante
                                this.loadingBouton = false

                                // Si ce n'est pas l'étape de validation Envoi du tag Eularian pour l'étape
                                if (this.etape != 6) {
                                    this.$storeCandidature.envoyerTagsAnalytics(this.$gtm, this.$eulerian, this.getTagPath(), this.getTagType(), false, null);
                                }
                            }
                        }
                    }
                }
            },

            // Fonction chargement de la candidature
            chargerCandidature(candidatureId, key) {
                // appeler le web service de la candidature
                return this.$http.post("ChargerCandidatureECE?CdtId=" + candidatureId + "&Key=" + key);
            },

            // Récupérer la première étape invalide, si non retourner la valeur en entrée
            checkPremierEtapeInvalide(etapeSuivante) {
                // Etape 1
                if (!this.$storeCandidature.etapeIentificationValide) {
                    this.showErrorValidation = false; // On cache le message d'erreur de validation car nous avons les message d'erreurs des contrôles
                    return 1
                }

                //Etape = 2
                if (!this.$storeCandidature.etapeCoixProgrammeValide) {
                    this.showErrorValidation = false; // On cache le message d'erreur de validation car nous avons les message d'erreurs des contrôles
                    return 2
                }

                // Etape 3
                if (!this.$storeCandidature.etapeInfoSpplementairesValide) { return 3 }

                //// Etape 4
                //if (!this.$storeCandidature.etapeInfoSpplementaires2Valide) { return 4 }

                // Etape 4
                if (this.$storeCandidature.tailleUpload > 20) { return 4 }

                // Etape 5
                if (!this.$storeCandidature.etapePaiementValide) {
                    return 5;
                }

                this.showErrorValidation = false;
                return etapeSuivante
            },

            // Validation des contrôles
            validerFormulaire() {
                var returnValid = true;

                // Etape 1
                if (this.etape == 1) {
                    if (!this.$storeCandidature.etapeIentificationValide || this.$storeCandidature.numeroTelephoneVide()) {
                        this.showErrorValidation = false; // On cache le message d'erreur de validation car nous avons les message d'erreurs des contrôles
                        this.loadingBouton = false
                        return false;
                    }

                    this.showErrorValidation = false;
                    return true;
                }

                //Etape = 2
                if (this.etape == 2) {
                    if (!this.$storeCandidature.etapeCoixProgrammeValide) {
                        this.showErrorValidation = false; // On cache le message d'erreur de validation car nous avons les message d'erreurs des contrôles
                        return false;
                    }
                    this.showErrorValidation = false;
                    return true;
                }

                // Etape 3
                if (this.etape == 3) {
                    if (!this.$storeCandidature.etapeInfoSpplementairesValide) {
                        return false;
                    }
                    this.showErrorValidation = false;
                    return true;
                }

                //// Etape 4
                //if (this.etape == 4) {
                //    if (!this.$storeCandidature.etapeInfoSpplementaires2Valide) {
                //        return false;
                //    }
                //    this.showErrorValidation = false;
                //    return true;
                //}

                // Etape 4
                if (this.etape == 4) {
                    if (this.$storeCandidature.tailleUpload > 20) {
                        return false;
                    }
                    this.showErrorValidation = false;
                    return true;
                }

                // Etape 5
                if (this.etape == 5) {
                    if (!this.$storeCandidature.etapePaiementValide) {
                        return false;
                    }
                    this.showErrorValidation = false;
                    return true;
                }

                // Etape 6
                if (this.etape == 6) {
                    // Mettre le message d'erreur de validation
                    this.messageErreurValidation = "Veuillez renseigner tous les champs obligatoires pour 'Valider' votre candidature";


                    // Renvoyé sur la bonne étape manquante
                    if (!this.$storeCandidature.ValidationIdentificationOK) {
                        this.showErrorValidation = true;
                        returnValid = false;
                        if (this.etape > 1) this.etape = 1;
                    }
                    if (!this.$storeCandidature.ValidationChoixProgrammeOK) {
                        this.showErrorValidation = true;
                        returnValid = false;
                        if (this.etape > 2) this.etape = 2;
                    }
                    if (!this.$storeCandidature.ValidationInformationSupplementaireOK) {
                        this.showErrorValidation = true;
                        returnValid = false;
                        if (this.etape > 3) this.etape = 3;
                    }

                    // Liste de l'étape info supplémentaire
                    if (!this.ValiderListesInfoSupp()) {
                        this.showErrorValidation = true;
                        if (this.etape > 3) this.etape = 3;
                        returnValid = false;
                    }

                    // Liste de docuements manquantes
                    if (!this.$storeCandidature.ValiderListesPiecesJointes()) {
                        this.showErrorValidation = true;
                        if (this.etape > 4) {
                            this.etape = 4;
                            this.messageErreurValidation = "Vous avez encore des pièces justificatives à fournir.";
                        }
                        returnValid = false;
                    }

                    // Vérifier si les frais de candiature sont payés
                    if (!this.$storeCandidature.ValiderPaiement()) {
                        this.showErrorValidation = true;
                        if (this.etape > 5) {
                            this.messageErreurValidation = "Les frais de candidature ne sont pas réglés";
                            this.etape = 5;
                        }
                        returnValid = false;
                    }

                    // Vérifier si la forme de validation est valide
                    if (!this.$storeCandidature.etapeValidationValide) {
                        returnValid = false;
                    }

                    if (returnValid) {
                        this.showErrorValidation = false;
                        this.etape = 6;
                    }
                }

                return returnValid;
            },

            // Vérifier la validation des listes de létape info supplémentaires
            ValiderListesInfoSupp() {
                if (!this.$storeCandidature.sasCandidature.ListeParcoursScolaire ||
                    this.$storeCandidature.sasCandidature.ListeParcoursScolaire.length == 0) {
                    this.$storeCandidature.ValidationInformationSupplementaireOK = false
                    return false
                }
                return true
            },

            // Vérifier la validation des listes de létape info supplémentaires
            ValiderListesInfoSupp2() {
                if (!this.$storeCandidature.sasCandidature.ListeLangues ||
                    this.$storeCandidature.sasCandidature.ListeLangues.length == 0) {
                    this.$storeCandidature.ValidationInformationSupplementaire2OK = false
                    return false
                }
                return true
            },

            // Mettre à jours les états de validité des lsites
            MajIconeValidationListes() {
                this.ValiderListesInfoSupp()
                this.ValiderListesInfoSupp2()
                this.$storeCandidature.ValiderListesPiecesJointes()
                this.$storeCandidature.ValiderPaiement()
            },

            // Charger la fiche s'il on a, appelé après le chargement de la configuration
            chargerFormulaireEcole() {
                // Récupérer l'id passé en paramètre dans l'url, s'il y on a, on charge la candidature
                if (this.$route.query.cdt) {
                    // Activer flag de chargement
                    this.$storeCandidature.loadingCandidature = true
                    this.$storeCandidature.sasCandidature.IdCrypte = this.$route.query.cdt;
                    this.$storeCandidature.sasCandidature.KeyCrypte = this.$route.query.kr;

                    // Chargement de la candidature
                    this.chargerCandidature(this.$route.query.cdt, this.$route.query.kr)
                        .then(response => {
                            // Success
                            if (response.data) {
                                this.$storeCandidature.affecterSasCandidature(response.data);
                                // Cocher la session choisi s'il y en a
                                this.$storeCandidature.cocherSessionChoisie();

                                // Si la candidature n'est pas en cours, on passe directement à l'étape 6
                                if (this.$storeCandidature.sasCandidature.Statut && this.$storeCandidature.configurationClient.StatutCandidatureEnCoursId
                                    && this.$storeCandidature.sasCandidature.Statut.Id != this.$storeCandidature.configurationClient.StatutCandidatureEnCoursId) {
                                    this.etape = 6;
                                    // Arréter le flag de chargement
                                    this.$storeCandidature.loadingConfig = false
                                    this.$storeCandidature.loadingCandidature = false
                                    return;
                                }

                                // Charger la liste des programmes
                                this.$storeCandidature.chargerProgrammes(this.dataIdEcoleEce);

                                //Vérifier si le formulaire est lancé àpartir du retour Mercanet (c.a.d la data est aliemnté par la réponse Mercanet)
                                if (this.$route.query.pay) {
                                    //On positionne le formulaire sur l'étape de paiement
                                    this.etape = 5;

                                    // Mettre à jour le mode de paiement
                                    this.$storeCandidature.sasCandidature.ModePaiementId = this.$storeCandidature.sasCandidature.ModePaiement ? this.$storeCandidature.sasCandidature.ModePaiement.Id.toString() : this.$storeCandidature.configurationClient.ModePaiementCbId.toString()
                                    this.$storeCandidature.sasCandidature.PaiementVirement = this.$storeCandidature.sasCandidature.ModePaiement && this.$storeCandidature.sasCandidature.ModePaiement.Id == this.$storeCandidature.configurationClient.ModePaiementVirementId

                                    // charger le dto de paiement mercanet si le paiement n'est pas réalisé
                                    if (!this.$storeCandidature.sasCandidature.PaiementRealise) {
                                        this.$storeCandidature.chargerObjetDePaiement(this.$storeCandidature.sasCandidature.IdCrypte, this.$storeCandidature.sasCandidature.KeyCrypte)
                                            .then(response => {
                                                if (response.data) {
                                                    this.$storeCandidature.paiemenyDto = response.data;
                                                }
                                            });
                                    }
                                    // On remet l'url de la fiche
                                    this.$router.push("/ece?cdt=" + this.$storeCandidature.sasCandidature.IdCrypte + "&kr=" + this.$storeCandidature.sasCandidature.KeyCrypte);
                                }

                                // Afficher les flag de validité
                                this.MajIconeValidationListes();
                                this.showValidationFlag = true

                                // Pour l'étape 1 on envoie le tag Eulerian après le chargement de l'étape pour avoir l'email
                                if (this.etape == 1) {
                                    this.$storeCandidature.envoyerTagsAnalytics(this.$gtm, this.$eulerian, this.getTagPath(), this.getTagType(), false, null);
                                }
                            }
                            // Arréter le flag de chargement
                            this.$storeCandidature.loadingCandidature = false
                        }) // On cas d'erreur on renvoi vers le formulaire de saisie vide
                        .catch(() => {
                            // Arréter le flag de chargement
                            this.$storeCandidature.loadingCandidature = false
                            alert("La Candidature est introuvable. Vous allez être redirigé vers le formulaire de saisie de nouvelle Candidature.");
                            //alert("Suite à une mise à jour de sécurité, vous receverez une nouvelle url dans les plus brefs délais pour finaliser votre candidature.");
                            this.$storeCandidature.initCandidature();
                            this.$router.push("/ece");
                        });
                } else {
                    this.$storeCandidature.initCandidature();
                }
            },

            // Appel du web service de mise des candidature : on passe le numéro de l'étape et un flag pour dire si on revient sur l'étape d'avant
            // etapeSuivante : Etape suivante
            // retour ==> true/false : précedente ou pas
            executerEtChangerEtape(etapeSuivante, retour) {
                this.loadingBouton = true
                this.showError = false;
                this.showErrorValidation = false;

                // Si le contact est inactif depuis trop longtemps.
                if (!this.$storeCandidature.VerifPeriodActivite()) {
                    this.loadingBouton = false
                    return
                }

                // Si précédente dans l'étape de validation ou de paiement on fait juste un pas en arrière
                if (retour && (this.etape == 6)) {
                    this.etape = etapeSuivante;
                    this.loadingBouton = false
                    // Réinitialiser le flag de modification de la candidature
                    this.$storeCandidature.candidatureChanged = false
                    return;
                }

                // Sauvegarder la date de naissance avant envoie pour l'email de log en cas de problème
                this.$storeCandidature.sasCandidature.Identification.DateNaissanceAvantConversion = this.$storeCandidature.sasCandidature.Identification.DateNaissance

                // Si la date de naissance est dans le format GMT,
                // On la convertie avant l'envoi au webservice pour ne pas avoir un retour en arrière de deux heure (13/01/2012 00:00:00 ==> 12/01/2012 22:00:00)
                if (this.$utils.verifierDateFormatGMT(JSON.stringify(this.$storeCandidature.sasCandidature.Identification.DateNaissance))) {
                    this.$storeCandidature.sasCandidature.Identification.DateNaissance = this.$storeCandidature.sasCandidature.Identification.DateNaissance ? this.$moment(this.$storeCandidature.sasCandidature.Identification.DateNaissance).format('DD/MM/YYYY') : ''
                }

                this.$storeCandidature.candidatureEnDouble = false
                this.$http.post("CreerMajCandidatureECE?Etape=" + this.etape, JSON.stringify(this.$storeCandidature.sasCandidature))
                    .then(response => {
                        // Success
                        if (response.data) {
                            // Vérifier si la candidature est en double
                            if (response.data.IdCrypte == this.$storeCandidature.constantes.motCleDoublon) {
                                this.$storeCandidature.candidatureEnDouble = true
                                this.loadingBouton = false
                                return
                            }

                            // Contournement du problème de perte du nom de programme en retournant du webservice
                            // A l'étape création du choix de programme, le NomPogramme revient un objet vide '{}'
                            // L'origine du problème n'est pas trouvé
                            if (this.$storeCandidature.sasCandidature.ChoixProgramme != null
                                && this.$storeCandidature.sasCandidature.ChoixProgramme.NomProgramme != null
                                && response.data.ChoixProgramme.NomProgramme != null && response.data.ChoixProgramme.NomProgramme.Id == null) {
                                // Si le programme est vide en revenant du web service, on le réaffecte
                                response.data.ChoixProgramme.NomProgramme = this.$storeCandidature.sasCandidature.ChoixProgramme.NomProgramme
                            }


                            // Initialiser la taille des fichier à envoyer
                            this.$storeCandidature.tailleUpload = 0

                            this.$storeCandidature.affecterSasCandidature(response.data);
                            // Afficher les flag de validité des étapes
                            this.MajIconeValidationListes();
                            this.showValidationFlag = true
                            if (retour) {
                                if (this.etape > 1) {
                                    this.etape = etapeSuivante
                                    // Réinitialiser le flag de modification de la candidature
                                    this.$storeCandidature.candidatureChanged = false
                                    this.loadingBouton = false
                                }
                            } else {
                                // Si c'est l'étape 1, on met à jour l'url avec l'id
                                if (!this.candidatureCharge && this.etape == 1) {
                                    this.candidatureCharge = true;
                                    this.$router.push(
                                        "/ece?cdt=" + this.$storeCandidature.sasCandidature.IdCrypte + "&kr=" + this.$storeCandidature.sasCandidature.KeyCrypte
                                    );
                                }

                                // Si c'est létape du choix de programme, on vérifie si ça nécessite une rdirection pour concours
                                if (this.etape == 2) {
                                    this.$storeCandidature.verifierRedirectionConcours().then(response => {
                                        this.$storeCandidature.redirectionConcours = response.data
                                        if (this.$storeCandidature.redirectionConcours.AfficherDialog) {
                                            this.etape = 2
                                            this.loadingBouton = false
                                            // Réinitialiser le flag de modification de la candidature
                                            this.$storeCandidature.candidatureChanged = false
                                            return
                                        }
                                        else {
                                            this.etape = etapeSuivante
                                            this.loadingBouton = false

                                            // Si ce n'est pas l'étape de validation Envoi du tag Eularian pour l'étape
                                            if (this.etape != 6) {
                                                this.$storeCandidature.envoyerTagsAnalytics(this.$gtm, this.$eulerian, this.getTagPath(), this.getTagType(), false, null);
                                            }
                                        }
                                    })
                                }
                                else {
                                    // On passe à l'étape suivante
                                    if (this.etape < 6) {
                                        this.etape = etapeSuivante
                                        this.loadingBouton = false
                                        // Réinitialiser le flag de modification de la candidature
                                        this.$storeCandidature.candidatureChanged = false

                                        // Si ce n'est pas l'étape de validation Envoi du tag Eularian pour l'étape
                                        if (this.etape != 6) {
                                            this.$storeCandidature.envoyerTagsAnalytics(this.$gtm, this.$eulerian, this.getTagPath(), this.getTagType(), false, null);
                                        }
                                    }
                                    else {
                                        if (this.etape == 6 && etapeSuivante == 6) {
                                            // Etape de validation exécuté
                                            this.$storeCandidature.envoyerTagsAnalytics(this.$gtm, this.$eulerian, this.getTagPath(), this.getTagType(), true, null);
                                        }
                                    }
                                }

                                /////// Après le changement de l'étape ///////
                                // Si on est dans l'étape de paiement et le paiement n'est pas encore réalisé
                                if (this.etape == 5) {
                                    // Mettre à jour le mode de paiement
                                    this.$storeCandidature.sasCandidature.ModePaiementId = this.$storeCandidature.sasCandidature.ModePaiement ? this.$storeCandidature.sasCandidature.ModePaiement.Id.toString() : this.$storeCandidature.configurationClient.ModePaiementCbId.toString()
                                    this.$storeCandidature.sasCandidature.PaiementVirement = this.$storeCandidature.sasCandidature.ModePaiement && this.$storeCandidature.sasCandidature.ModePaiement.Id == this.$storeCandidature.configurationClient.ModePaiementVirementId

                                    // Appeler le web service d'initialisation du paiement
                                    this.$storeCandidature.chargerObjetDePaiement(this.$storeCandidature.sasCandidature.IdCrypte, this.$storeCandidature.sasCandidature.KeyCrypte)
                                        .then(response => {
                                            if (response.data) {
                                                this.$storeCandidature.paiemenyDto = response.data;
                                            }
                                        });
                                }

                            }
                            // on cache le message de bug de chargement
                            this.showError = false
                        } else {
                            this.showError = true
                            this.loadingBouton = false
                        }
                    })
                    .catch(() => {
                        this.showError = true
                        this.loadingBouton = false
                    });
            }
        },

        created() {
            // Définir le titre du formulaire
            document.title = 'Candidature - ECE'

            // Init le tag Eulerian analytics pour le formulaire
            this.$storeCandidature.envoyerTagAnalyticsEulerian(this.$eulerian, this.getTagPath(), this.getTagType(), false, null);

            // Récupérer les paramètres SourceDetaillee de l'url
            this.$storeCandidature.getSourceDetailleePrams(this.$route.query)

            // Spécification de la langue du formulaire
            if (this.$route.query.loc) {
                this.$storeCandidature.langueFormulaire = this.$route.query.loc;
            }
            else {
                this.$storeCandidature.langueFormulaire = "fr"
            }

            // Alimenter l'information école du formulaire
            this.$storeCandidature.dataIdEcoleFormulaire = this.dataIdEcoleEce
            this.$storeCandidature.dataIdFormulaireCandidature = this.dataIdFormulaireEce

            // Activer le flag de chargement
            this.$storeCandidature.loadingConfig = true

            // //On charge la configuration client (Ids, DescIds,...) + les listes déroulantes
            this.$storeCandidature.ChargerConfiguration(this.dataIdEcoleEce, this.dataIdFormulaireEce)
                .then(response => {
                    // Success
                    if (response.data) {
                        this.$storeCandidature.configurationClient = response.data;
                        //this.$storeCandidature.configurationClient.Loaded = true

                        // Si la configuration est chargée, on ajoute le tag oneTrust à l'entête de la page
                        this.$storeCandidature.addOneTrustTag(this.$storeCandidature.configurationClient.ParamFormulaire.IdTagsCMPOneTrust)

                        //Repositionner la france en tête de la liste des pays
                        this.$storeCandidature.paysFranceTeteDeListe()

                        // Charger les liste déroulante
                        this.$storeCandidature.chargerListesDeroulantes(true);

                        // Afficher les flag de validité
                        this.MajIconeValidationListes();
                        // Cocher la session choisi s'il y en a
                        this.$storeCandidature.cocherSessionChoisie();

                        this.$storeCandidature.configurationClient.Loaded = true
                    }
                }).catch(() => {
                    // Arréter le flag de chargement
                    this.$storeCandidature.loadingConfig = false
                })

            // Appeler le chargement du formulaire de l'école
            this.chargerFormulaireEcole();
        }
    }
</script>
<style>
    #input-usage .v-input__prepend-outer,
    #input-usage .v-input__append-outer,
    #input-usage .v-input__slot,
    #input-usage .v-messages {
        border: 1px dashed rgba(0, 0, 0, 0.4);
    }

    .center {
        text-align: center;
    }
</style>